import { render, staticRenderFns } from "./openCard.vue?vue&type=template&id=4f0a71be&scoped=true&"
import script from "./openCard.vue?vue&type=script&lang=js&"
export * from "./openCard.vue?vue&type=script&lang=js&"
import style0 from "./openCard.vue?vue&type=style&index=0&id=4f0a71be&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0a71be",
  null
  
)

export default component.exports